import { useEffect } from 'react';
export function useWakeLock(lock) {
    useEffect(() => {
        if (lock && navigator.wakeLock) {
            const sentinelPromise = navigator.wakeLock
                .request('screen')
                .catch(e => { });
            return () => {
                sentinelPromise.then(sentinel => sentinel?.release());
            };
        }
    }, [lock]);
}
//# sourceMappingURL=useWakeLock.js.map